import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import lscache from "lscache";

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Select from "react-select";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import AgGridReactEx from "@app/components/AgGridReactEx";

const ManageMenu = ({}) => {
    const [loadingData, setLoadingData] = useState(true);
    const loginBranchInfo = utility.getLoginBranchInfo();
    const [menuCategories, setMenuCategories] = useState(false);
    const [menus, setMenus] = useState(false);
    const [menuArranged, setMenuArranged] = useState(false);
    const [userGroups, setUserGroups] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });
    const [showModal, setShowModal] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState(false);
    const [list, setList] = useState(null);
    const isDeveloper = localStorage.getItem("login_user_roleArr").includes("developer");

    const listColumn = [
        {
            headerName: "ID",
            minWidth:50,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "카테고리",
            field: "MC_ID",
            minWidth:80,
            cellRenderer: (params) => {
                const mc = menuCategories.find((mc) => mc.ID == params.value);
                return mc ? mc.NAME : "";
            },
        },
        {
            headerName: "최상위 메뉴",
            field: "gName",
            minWidth:100,
            cellRenderer: (params) => {
                if(params.data.DEPTH == 0) {
                    return params.data.NAME;
                } else if(params.data.DEPTH == 1) {
                    return params.data.pName;
                } else if(params.data.DEPTH == 2) {
                    return params.data.gName;
                }
                return '-';
            },
        },
        {
            headerName: "상위 메뉴",
            field: "pName",
            minWidth:100,
            cellRenderer: (params) => {
                if(params.data.DEPTH == 0) {
                } else if(params.data.DEPTH == 1) {
                    return params.data.NAME;
                } else if(params.data.DEPTH == 2) {
                    return params.data.pName;
                }
                return '-';
            },
        },
        {
            headerName: "메뉴",
            field: "NAME",
            minWidth:100,
            cellRenderer: (params) => {
                if(params.data.DEPTH == 0) {
                } else if(params.data.DEPTH == 1) {
                } else if(params.data.DEPTH == 2) {
                    return params.data.NAME;
                }
                return '-';
            },
        },
        {
            headerName: "관리",
            field: "id",
            width: 80,
            minWidth: 70,
            cellClass: "text-center",
            cellRendererFramework: function (params) {
                return <div className='btn-group'>
                <button
                    className='btn pl-2 pr-2 pt-1 pb-1 btn-primary'
                    onClick={() => onRowClicked(params)}
                >
                    수정
                </button>
            </div>
            },
        }
        
    ];
    useEffect(() => {
        if (!loginBranchInfo && !menus) {
            getData();
        }
        return () => {};
    }, [menus]);

    useEffect(() => {
        if (userGroups) {
            const newColumns = [...listColumn];  // 원래 컬럼을 복사하여 수정
    
            userGroups.forEach((g) => {
                newColumns.push({
                    headerName: g.NAME,
                    field: "authGroups",
                    width: g.NAME.length * 15,
                    minWidth: 85,
                    resizable: true,
                    cellClass: "text-center",
                    cellRendererFramework: (params) => {
                        const chk = params.value ? params.value.find((a) => a.UG_ID == g.ID) : null;
                        return (
                            <input
                                type="checkbox"
                                value={g.ID}
                                defaultChecked={chk != null ? "checked" : ""}
                                onChange={(e) => onChangeGroup(e, params.data.ID, tableData)}
                            />
                        );
                    },
                });
            });
    
            setList(newColumns);  // 새로운 컬럼을 상태로 저장
        }
    
        return () => {};
    }, [userGroups, tableData]);

    

    const getData = () => {
        axios({
            method: "get",
            url: `/api/system/mngr-menu/menu/${isDeveloper}`,
        })
            .then((res) => {
                const result = res.data;
                const menuArranged = [];
                result.menus.forEach((m) => {
                    if (m.DEPTH == 0) {
                        menuArranged.push({
                            ID: m.ID,
                            NAME: m.NAME,
                            DESC: m.DESC,
                            GROUP_ID: m.GROUP_ID,
                            IS_MODULE: m.IS_MODULE,
                            MC_ID: m.MC_ID,
                            DEPTH: m.DEPTH,
                            DISPLAY_ORDER: m.DISPLAY_ORDER,
                            child: [],
                        });
                    } else if (m.DEPTH == 1) {
                        menuArranged.forEach((parent) => {
                            if (parent.ID === m.GROUP_ID) {
                                parent.child.push({
                                    ID: m.ID,
                                    NAME: m.NAME,
                                    DESC: m.DESC,
                                    GROUP_ID: m.GROUP_ID,
                                    IS_MODULE: m.IS_MODULE,
                                    MC_ID: m.MC_ID,
                                    DEPTH: m.DEPTH,
                                    DISPLAY_ORDER: m.DISPLAY_ORDER,
                                    child: [],
                                });
                            }
                        });
                    } else if (m.DEPTH == 2) {
                        menuArranged.forEach((parent) => {
                            parent.child.forEach((p_child) => {
                                if (p_child.ID === m.GROUP_ID) {
                                    p_child.child.push({
                                        ID: m.ID,
                                        NAME: m.NAME,
                                        DESC: m.DESC,
                                        GROUP_ID: m.GROUP_ID,
                                        IS_MODULE: m.IS_MODULE,
                                        MC_ID: m.MC_ID,
                                        DISPLAY_ORDER: m.DISPLAY_ORDER,
                                        DEPTH: m.DEPTH,
                                    });
                                }
                            });
                        });
                    }
                });
                menuArranged.forEach((m) => {
                    m.child.map((mc) => {
                        mc.child.sort((a, b) => a.DISPLAY_ORDER - b.DISPLAY_ORDER)
                    });
                    m.child.sort((a, b) => a.DISPLAY_ORDER - b.DISPLAY_ORDER);
                });
                menuArranged.sort((a, b) => a.DISPLAY_ORDER - b.DISPLAY_ORDER);
               
                setMenuCategories(result.categories);
                setMenus(result.menus);
                setMenuArranged(menuArranged);
                setUserGroups(result.userGroups);
                setLoadingData(false);
                applyData(searchParam, result.menus);

            })
            .catch((error) => {
                console.log(error);
                setLoadingData(false);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const defaultColDef = {
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };

    const onRowClicked = (params) => {
        if (params && params.data) {
            setSelectedMenu(params.data);
            setShowModal(true);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, menus);
    };

    const applyData = (searchParam, menus) => {
        var tableDataSearch = listSearch(searchParam, menus);
        tableDataSearch.map((mn) => {
            mn.PATH_EXACT_TEXT = mn.PATH_EXACT ? "정확" : "부정확";
        });
        setTableData(tableDataSearch);
        setSearchParam(searchParam);
    };

    const searchField = ["NAME"];
    const listSearch = (searchParam, list) => {
        var tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (item[field] && item[field].indexOf(searchParam.value) >= 0) {
                        tableDataNew.push(item);
                    }
                });
            });
        }
        return tableDataNew;
    };

    const onChangeGroup = (e, id) => {
        const isChecked = e.target.checked;
        const ug_id = e.target.value;
        axios({
            method: isChecked ? "put" : "delete",
            url: `${Constant.API_DOMAIN}/api/system/mngr-menu/menu/${id}/${e.target.value}`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    lscache.remove(commonData.getCacheKey(Constant.LSCACHE_KEY.MENUS));
                } else {
                    alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    console.log(result.data);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    let gridApi = null;
    const onGridReady = (params) => {
        gridApi = params.api;
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">TAS Menu 관리</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row align-items-end">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                            <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                <span>
                                    {tableData && tableData.length > 0 ? tableData.length.toLocaleString() : "0"} / {menus && menus.length > 0 ? menus.length.toLocaleString() : "0"}
                                </span>
                            </h5>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pb-2 text-right" >{(isDeveloper) && ("* 모듈은 개발자 계정에서만 노출됩니다.")}</div>
                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                            <InputGroup className="input-group my-group">
                            
                                <InputGroup.Append>
                                    <Button
                                        className="btn btn-success mr-3"
                                        onClick={() => {
                                            setSelectedMenu(false);
                                            setShowModal(true);
                                        }}
                                    >
                                        등록
                                    </Button>
                                </InputGroup.Append>
                                
                                <input
                                    className="form-control"
                                    type="text"
                                    value={searchParam.value}
                                    placeholder="메뉴 검색"
                                    onChange={(e) => {
                                        const param = { ...searchParam };
                                        param.value = e.target.value;
                                        setSearchParam(param);
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                                <InputGroup.Append>
                                    <Button className="btn btn-primary" onClick={onSearch}>
                                        검색
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            {!loadingData && (
                                <AgGridReactEx
                                    defaultColDef={defaultColDef}
                                    columnDefs={list}
                                    rowData={tableData}
                                    //onRowClicked={onRowClicked}
                                    height={700}
                                    pagination={false}
                                    onGridReady={onGridReady}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <MenuModal
                show={showModal}
                userGroups={userGroups}
                isNew={selectedMenu == false}
                onHide={(dataRefresh) => {
                    if (dataRefresh) {
                        setSelectedMenu(false);
                        setMenus(false);
                    }
                    setShowModal(false);
                }}
                selectedMenu={selectedMenu}
                menus={menuArranged}
                menuCategories={menuCategories}
            />
        </div>
    );
};

const MenuModal = ({ show, onHide, isNew, selectedMenu = false, userGroups, menuCategories, menus }) => {
    const baseMenu = {
        ID: null,
        COMPONENT_NAME: "",
        ICON: "",
        NAME: "",
        DESC: "",
        PATH: "",
        PATH_EXACT: "1",
        MC_ID: "1",
        DEPTH: "",
        GROUP_ID: null,
        DISPLAY_ORDER: "1",
        IS_NAV: "1",
        IS_MODULE: "0",
        CREATE_DATE: "",
        UPDATE_DATE: "",
        authGroups: [],
    };

    const isDeveloper = localStorage.getItem("login_user_roleArr").includes("developer");

    const [menu, setMenu] = useState(selectedMenu ? selectedMenu : { ...baseMenu });
    const [parentMenuOption, setParentMenuOption] = useState([{ label: "상위 메뉴를 선택해 주세요.", value: "", active: false, name: "GROUP_ID" }]);
    useEffect(() => {
        setMenu(selectedMenu ? selectedMenu : { ...baseMenu });
        return () => {};
    }, [show]);

    useEffect(() => {
        if (menus && menus.length) {
            let menuOption = [];
            menuOption.push({ label: "상위 메뉴를 선택해 주세요.", value: "", active: false, name: "GROUP_ID" });
            menus.map((mn) => {
                if (mn.MC_ID == menu.MC_ID) {
                    let paddingLeft = mn.DEPTH * 20;
                    const label = (
                        <span style={{ paddingLeft: `${paddingLeft}px` }}>
                            {paddingLeft > 0 ? "- " : ""}
                            {mn.NAME}
                        </span>
                    );
                    menuOption.push({ label: label, value: mn.ID, active: false, name: "GROUP_ID" });
                    if (mn.child.length) {
                        mn.child.forEach((mc) => {
                            if(mc.IS_MODULE == 1) return;
                            paddingLeft = mc.DEPTH * 20;
                            const label = (
                                <span style={{ paddingLeft: `${paddingLeft}px` }}>
                                    {paddingLeft > 0 ? "- " : ""}
                                    {mc.NAME}
                                </span>
                            );
                            menuOption.push({ label: label, value: mc.ID, name: "GROUP_ID" });

                            if (mc.child.length) {
                                mc.child.forEach((mcc) => {
                                    if(mc.IS_MODULE == 1) return;
                                    paddingLeft = mcc.DEPTH * 20;

                                    const label = (
                                        <span style={{ paddingLeft: `${paddingLeft}px` }}>
                                            {paddingLeft > 0 ? "- - " : ""}
                                            {mcc.NAME}
                                        </span>
                                    );
                                    menuOption.push({ label: label, value: mcc.ID, name: "GROUP_ID" });
                                });
                            }
                        });
                    } else {
                    }
                }
            });
            setParentMenuOption(menuOption);
        }
        return () => {};
    }, [menu.MC_ID]);

    const changeHandler = (e) => {
        var { name, value } = e.target;
        const newMenu = { ...menu };
        newMenu[name] = value;
        if (newMenu.GROUP_ID == "") {
            newMenu.GROUP_ID = null;
        }

        setMenu(newMenu);
    };

    const onParentMenuSelect = (e) => {
        var { name, value } = e;
        const newMenu = { ...menu };
        newMenu[name] = value;
        if (newMenu.GROUP_ID == "") {
            newMenu.GROUP_ID = null;
        }

        setMenu(newMenu);
    };

    const changeMenuAuthGroupHandler = (e) => {
        const { name, value, checked } = e.target;
        const authExist = menu.authGroups.includes((ag) => ag.UG_ID == value);
        const newMenu = { ...menu };
        newMenu.authGroups = [...menu.authGroups];
        if (checked) {
            newMenu.authGroups.push({ M_ID: newMenu.ID, UG_ID: parseInt(value) });
        } else {
            const idx = newMenu.authGroups.findIndex((ag) => {
                return ag.UG_ID == value;
            });
            if (idx > -1) {
                newMenu.authGroups.splice(idx, 1);
            }
        }
        setMenu(newMenu);
    };

    const upsertData = () => {
        const { key, value, description } = menu;

        axios({
            method: "post",
            url: `/api/system/mngr-menu/menu`,
            data: {
                ...menu,
            },
        })
            .then((res) => {
                alert(`메뉴를 ${isNew ? "추가했습니다." : "수정했습니다."}`);
                onClose(true);
                lscache.remove(commonData.getCacheKey(Constant.LSCACHE_KEY.MENUS));
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const deleteData = () => {
        var answer = true;
        if (menu.authGroups.length) {
            if (!window.confirm(`해당 메뉴를 사용하는 그룹이 있습니다. 그래도 삭제하시겠습니까?`)) {
                answer = false;
            }
        }
        if (answer) {
            if (window.confirm(`해당 메뉴를 정말 삭제하시겠습니까?\n${menu.NAME}`)) {
                axios({
                    method: "delete",
                    url: `/api/system/mngr-menu/menu/${menu.ID}`,
                })
                    .then((res) => {
                        alert("메뉴가 삭제 되었습니다.");
                        onClose(true);
                        lscache.remove(commonData.getCacheKey(Constant.LSCACHE_KEY.MENUS));
                    })
                    .catch((error) => {
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        }
    };
    const onClose = (dataRefresh) => {
        setMenu({ ...baseMenu });
        onHide(dataRefresh);
    };

    return (
        <Modal
            show={show}
            size="lg"
            onHide={() => {
                onClose(false);
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">메뉴 {isNew ? "등록" : "수정 - " + menu.ID}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input type="hidden" className="form-control" id="ID" name="ID" tabIndex="1" value={menu.ID || ""} />
                <div className="row">
                    <div className="col">
                        <label htmlFor="NAME">메뉴</label>
                        <input type="text" className="form-control" id="NAME" name="NAME" tabIndex="2" onChange={changeHandler} value={menu.NAME || ""} />
                    </div>
                    {!isDeveloper && (
                            <div className="col-3">
                                <label htmlFor="ICON">
                                    메뉴 아이콘
                                    <span className="ml-2"></span>
                                    {menu.ICON && <i className={menu.ICON} />}
                                    {!menu.ICON && <span className="text-danger">없음</span>}
                                </label>
                                <input type="text" className="form-control" id="ICON" name="ICON" rows="3" tabIndex="3" onChange={changeHandler} value={menu.ICON || ""} />
                            </div>
                            
                    )}
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="NAME">설명</label>
                        <input type="text" className="form-control" id="DESC" name="DESC" tabIndex="3" onChange={changeHandler} value={menu.DESC || ""} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-4">
                        <label htmlFor="MC_ID">카테고리</label>
                        <select className="form-control mt-2" id="MC_ID" name="MC_ID" value={menu.MC_ID || ""} autoFocus onChange={changeHandler}>
                            {menuCategories &&
                                menuCategories.map((mc) => {
                                    return (
                                        <option key={`mc_id_${mc.NAME}`} id={"mc_id_" + mc.ID} value={mc.ID}>
                                            {mc.NAME}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="col-5">
                        <label htmlFor="GROUP_ID" className="pb-2">상위 메뉴</label>
                        <Select
                            id="GROUP_ID"
                            name="GROUP_ID"
                            onChange={onParentMenuSelect}
                            placeholder="상위 메뉴를 선택해 주세요"
                            value={parentMenuOption.find((o) => o.value == menu.GROUP_ID) ? parentMenuOption.find((o) => o.value == menu.GROUP_ID) : parentMenuOption[0]}
                            options={parentMenuOption}
                        />
                    </div>
                    <div className="col-3">
                        <label htmlFor="COMPONENT_NAME" className="pb-2">정렬 순서(오름차순)</label>
                        <input type="text" className="form-control" id="DISPLAY_ORDER" name="DISPLAY_ORDER" rows="3" tabIndex="3" onChange={changeHandler} value={menu.DISPLAY_ORDER} />
                    </div>
                </div>

                {
                (isDeveloper) && 
                    (
                        <div className="row mt-3">
                            <div className="col">
                                <label htmlFor="PATH">PATH</label>
                                <input type="text" className="form-control" id="PATH" name="PATH" rows="3" tabIndex="3" onChange={changeHandler} value={menu.PATH} />
                            </div>
                            <div className="col">
                                <label htmlFor="PATH_EXACT">PATH 정확도</label>
                                <select className="form-control mt-2" id="PATH_EXACT" name="PATH_EXACT" value={menu.PATH_EXACT} autoFocus onChange={changeHandler}>
                                    <option value="0">부정확</option>
                                    <option value="1">정확</option>
                                </select>
                            </div>
                        </div>
                    )
                }
                {(isDeveloper) && 
                    (
                        <div className="row mt-3">
                            <div className="col">
                                <label htmlFor="IS_NAV">네비게이션 메뉴 여부</label>
                                <select className="form-control mt-2" id="IS_NAV" name="IS_NAV" value={menu.IS_NAV} autoFocus onChange={changeHandler}>
                                    <option value="1">네비게이션 메뉴(메뉴 고정-기본)</option>
                                    <option value="0">페이지 갱신(메뉴 갱신)</option>
                                </select>
                            </div> 
                            <div className="col">
                                <label htmlFor="IS_MODULE">모듈 여부</label>
                                <select className="form-control mt-2" id="IS_MODULE" name="IS_MODULE" value={menu.IS_MODULE} autoFocus onChange={changeHandler}>
                                    <option value="0">-</option>
                                    <option value="1">모듈</option>
                                </select>
                            </div>
                        </div>
                        
                    )
                }

                {(isDeveloper) && 
                    (
                        <div className="row mt-3">
                            <div className="col">
                                <label htmlFor="COMPONENT_NAME">컴포넌트</label>
                                <input type="text" className="form-control" id="COMPONENT_NAME" name="COMPONENT_NAME" tabIndex="3" onChange={changeHandler} value={menu.COMPONENT_NAME || ""} />
                            </div>
                            <div className="col">
                                <label htmlFor="ICON">
                                    메뉴 아이콘
                                    <span className="ml-2"></span>
                                    {menu.ICON && <i className={menu.ICON} />}
                                    {!menu.ICON && <span className="text-danger">없음</span>}
                                </label>
                                <input type="text" className="form-control" id="ICON" name="ICON" rows="3" tabIndex="3" onChange={changeHandler} value={menu.ICON || ""} />
                            </div>
                        </div>
                        
                    )
                }

                <div className="row mt-3">
                    <div className="col">
                        <label htmlFor="createDate">등록일</label>
                        <input type="text" className="form-control" disabled id="createDate" name="createDate" value={menu.CREATE_DATE || ""} />
                    </div>
                    <div className="col">
                        <label htmlFor="updateDate">수정일</label>
                        <input type="text" className="form-control" disabled id="updateDate" name="updateDate" value={menu.UPDATE_DATE || ""} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {!isNew && (
                    <button className="btn btn-danger" onClick={deleteData}>
                        삭제
                    </button>
                )}
                <button className="btn btn-primary" onClick={upsertData}>
                    저장
                </button>
                <button className="btn btn-outline-dark" onClick={() => onHide(false)}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export { ManageMenu as default };
